module.exports = __webpack_public_path__ + "937c6a128095a6dde53fb2adfb8c7d99.pdf";